import theme from '../../theme/theme';

const {
  colors: { subtitle },
} = theme;

const styles = {
  container: {
    display: 'flex',
    flex: 1,
  },

  content__wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: '76px',
  },

  icon__image: {
    fontSize: '2.5em',
    borderRadius: 0,
    height: '80px',
    width: '80px',
  },

  content__subtitle: {
    color: subtitle,
    fontSize: '1.250em',
    fontWeight: 'normal',
    height: '1.750em',
    letterSpacing: '-0.031em',
    textAlign: 'center',
    width: '16.250em',
  },
};

export default styles;
